import { mount } from 'svelte';
import UpsellingComponent from './component/UpsellingComponent.svelte'; ;
import type UpsellingComponentProps from './component/UpsellingComponentProps';

export default (id: string) => {
  window.o_global.eventQBus.on('ft5.upselling.load', (event: { variationId: string }) => {
    const target = document.getElementById(id)!;
    mount<UpsellingComponentProps, object>(UpsellingComponent,
      { target, props: { variationId: event.variationId } },
    );
  });
};
